import { createUseStyles } from "react-jss";
import { ITheme } from "../../store/slices/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  root: {
    overflowY: "scroll",
    overflowX: "hidden",
    scrollSnapType: "y mandatory",
    position: "relative",
    minHeight: "80vh",
    // TODO: add constant
    paddingTop: 70,
    "-ms-overflow-style": "none" /* IE and Edge */,
    scrollbarWidth: "none" /* Firefox */,
    /* Hide scrollbar for Chrome, Safari and Opera */
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
  icon: {
    color: theme.colors.TextSilver,
    "&.active": {
      color: theme.colors.TextDefault,
    },
  },
  container: {
    display: "grid",
  },
  tabs: {
    padding: `${theme.spacing.space8}px ${theme.spacing.space16}px`,
    display: "flex",
    width: "100%",
    boxSizing: "border-box",
  },
  tabItem: {
    boxSizing: "border-box",
    display: "flex",
    width: "100%",
    alignItems: "center",
    padding: `${theme.spacing.space8}px ${theme.spacing.space12}px`,
    borderBottom: `2px solid ${theme.colors.Border1}`,
    gap: theme.spacing.space4,
    "&.active": {
      borderBottom: `2px solid ${theme.colors.Primary}`,
    },
  },
  videoList: {
    padding: `${theme.spacing.space20}px ${theme.spacing.space16}px`,
    display: "flex",
    gap: theme.spacing.space24,
    maxWidth: "100vw",
    boxSizing: "border-box",
    flexDirection: "column",
    paddingBottom: theme.spacing.space48 + theme.spacing.space36,
  },
}));
